import { Tonnage } from "./tonnage";

export class TonnageGridViewItem {
    id?: string;
    siteName?: string;
    siteId?: string;
    companyName?: string;
    companyId?: string;
    date?: Date;
    isExceptionalConvoy?: boolean;
    shipName?: string;
    shipId?:string;
    isLoading?: boolean;
    from?: string;
    fromId?: string;
    to?: string;
    toId?: string;
    quantity?: number;
    material?: string;
    materialId?: string;
    creationDate?: Date;
    tonnage?: Tonnage;
    isError?: boolean;
    billed?: boolean;
    constructor(tonnageGridViewItem?: TonnageGridViewItem) {
        this.id = tonnageGridViewItem?.id;
        this.siteName = tonnageGridViewItem?.siteName;
        this.siteId = tonnageGridViewItem?.siteId;
        this.companyName = tonnageGridViewItem?.companyName;
        this.companyId = tonnageGridViewItem?.companyId;
        this.date = tonnageGridViewItem?.date;
        this.isExceptionalConvoy = tonnageGridViewItem?.isExceptionalConvoy;
        this.shipName = tonnageGridViewItem?.shipName;
        this.shipId = tonnageGridViewItem?.shipId;
        this.isLoading = tonnageGridViewItem?.isLoading;
        this.from = tonnageGridViewItem?.from;
        this.fromId = tonnageGridViewItem?.fromId;
        this.to = tonnageGridViewItem?.to;
        this.toId = tonnageGridViewItem?.toId;
        this.quantity = tonnageGridViewItem?.quantity;
        this.material = tonnageGridViewItem?.material;
        this.materialId = tonnageGridViewItem?.materialId;
        this.creationDate = tonnageGridViewItem?.creationDate;
        this.tonnage = tonnageGridViewItem?.tonnage;
        this.isError = tonnageGridViewItem?.isError;
        this.billed = tonnageGridViewItem?.billed;
    }
}
